import { Component, Input } from '@angular/core'
import { Connection } from '@tv3/store/connection/connection.model'
import * as lodash from 'lodash'

// Pure presentational badge for a connection's Airbnb listing state. It renders only
// from Connection fields: the pause/liveness flags persisted on the saved room, and
// airbnbStatus (the listing approval category). Containers that want the approval badge
// live rather than as-of-the-last-room-save dispatch GetAirbnbListingStatus, whose
// effect refreshes connection.airbnbStatus in the store — this component stays dumb.
@Component({
  selector: 'app-airbnb-listing-status',
  templateUrl: './airbnb-listing-status.component.html',
  styleUrls: ['./airbnb-listing-status.component.scss'],
})
export class AirbnbListingStatusComponent {
  @Input() connection: Connection

  // Persisted room statuses predate the effect's snake_case normalization and may carry
  // raw Airbnb spellings ('ready for review'); normalize here so the switch matches both.
  get statusCategory(): string {
    return lodash.snakeCase(this.connection?.airbnbStatus || '')
  }
}
